import { useMemo } from 'react';
import { useProjectSidebarNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import type { UseReportsReturn } from './types.tsx';
import { extractData } from './utils/extract-data.tsx';

export const useReports = (): UseReportsReturn => {
	const { loading, error } = useProjectSidebarNavigation();
	const { hasSoftwareAccess } = useApplicationPermissions();
	const extractedData = useMemo(() => extractData(hasSoftwareAccess), [hasSoftwareAccess]);
	return { data: extractedData, loading, error };
};
